import { render, staticRenderFns } from "./trainingmange.vue?vue&type=template&id=0dc2c16f&scoped=true"
import script from "./trainingmange.vue?vue&type=script&lang=js"
export * from "./trainingmange.vue?vue&type=script&lang=js"
import style0 from "./trainingmange.vue?vue&type=style&index=0&id=0dc2c16f&prod&lang=less"
import style1 from "./trainingmange.vue?vue&type=style&index=1&id=0dc2c16f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc2c16f",
  null
  
)

export default component.exports